import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBurgerSoda, faUtensils } from '@fortawesome/pro-solid-svg-icons';
import { isAfter } from 'date-fns';
import { DeliveryType, GiftCard } from 'src/app/models';
import { SskOrderType } from 'src/app/store/self-service/self-service.selector';

export class SskHelper {
  static checkGiftCardValid(giftCard: GiftCard): string {
    let errorMessageKey: string;

    if (
      giftCard.expiry_date &&
      !isAfter(new Date(giftCard.expiry_date), new Date())
    ) {
      errorMessageKey = 'errors.giftCardExpired';
    } else if (+giftCard.balance <= 0) {
      errorMessageKey = 'errors.giftCardNoBalance';
    }

    return errorMessageKey;
  }

  static SskDeliveryTypeMapper: Record<
    DeliveryType,
    Partial<{
      orderType: SskOrderType;
    }>
  > = {
    [DeliveryType.DELIVERY]: {
      orderType: 'delivery'
    },
    [DeliveryType.TO_GO]: {
      orderType: 'takeout'
    },
    [DeliveryType.TO_TABLE]: {
      orderType: 'dinein'
    },
    [DeliveryType.PICK_UP]: {},
    [DeliveryType.TO_SEAT]: {},
    [DeliveryType.TO_ROOM]: {}
  };

  static SskOrderTypeMapper: Record<
    SskOrderType,
    {
      label: string;
      icon?: IconDefinition;
      src?: string;
      deliveryType: DeliveryType;
    }
  > = {
    delivery: {
      label: 'Delivery',
      src: 'assets/icon/self-service/moped.svg',
      deliveryType: DeliveryType.DELIVERY
    },
    dinein: {
      label: 'Dine-In',
      icon: faUtensils,
      deliveryType: DeliveryType.TO_TABLE
    },
    takeout: {
      label: 'Takeout',
      icon: faBurgerSoda,
      deliveryType: DeliveryType.TO_GO
    }
  };

  static AllOrderTypes: SskOrderType[] = ['dinein', 'takeout', 'delivery'];
}
